import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type ILeadTechnologyProfile, leadTechnologyProfilesManager } from '@inpart-io/padme-iap';

import { store } from '@/store';

import { getSearchModule } from '../base/search/module';
import { actions } from './actions';

const LEAD_TECHNOLOGY_PROFILE_MODULE = 'leadTechnologyProfile';

const dataObjectModule = getDataObjectsModule<ILeadTechnologyProfile>(leadTechnologyProfilesManager);
const searchModule = getSearchModule<ILeadTechnologyProfile>(leadTechnologyProfilesManager);

const leadTechnologyProfileModuleInstance = merge<unknown>(dataObjectModule, searchModule, { actions });
store.registerModule(LEAD_TECHNOLOGY_PROFILE_MODULE, leadTechnologyProfileModuleInstance);

export { LEAD_TECHNOLOGY_PROFILE_MODULE };
